import { render, staticRenderFns } from "./DataViewSidebarZone.vue?vue&type=template&id=683c15b2&scoped=true&"
import script from "./DataViewSidebarZone.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarZone.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarZone.vue?vue&type=style&index=0&id=683c15b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c15b2",
  null
  
)

export default component.exports